import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const formatNumero = (n) => {
  if (n === null || n === undefined) return "";
  return `#${String(n).padStart(6, "0")}`;
};

export const formatData = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
};

export const setMeta = ({ title, description, canonical, ogImage, ogType, ogUrl }) => {
  if (title) {
    document.title = title;
    setOg("og:title", title);
  }
  if (description) {
    setNamedMeta("description", description);
    setOg("og:description", description);
  }
  if (ogType) setOg("og:type", ogType);
  const url = ogUrl || canonical;
  if (url) setOg("og:url", url);
  if (canonical) setCanonical(canonical);
  if (ogImage) setOg("og:image", ogImage);
};

const setCanonical = (href) => {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setNamedMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setOg = (prop, content) => {
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const setOgImage = (url) => setOg("og:image", url);

export const cardImageUrl = (numero) =>
  `${API}/promises/${String(numero).padStart(6, "0")}/card.png`;

// Condivide solo il LINK alla pagina del messaggio.
export const shareLink = async ({ numero, testo, pageUrl, toast }) => {
  const numeroFmt = `#${String(numero).padStart(6, "0")}`;
  const text = `\u201c${testo}\u201d \u2014 Il Museo delle Promesse`;
  if (navigator.share) {
    try {
      await navigator.share({ title: `Messaggio ${numeroFmt}`, text, url: pageUrl });
      return;
    } catch {
      return;
    }
  }
  try {
    await navigator.clipboard.writeText(pageUrl);
    if (toast) toast.success("Link copiato");
  } catch {
    window.open(pageUrl, "_blank");
  }
};

// Condivide l'IMMAGINE della card via Web Share (file). Fallback: apre/scarica l'immagine.
export const shareCard = async ({ numero, testo, firma, toast }) => {
  const imgUrl = cardImageUrl(numero);
  const numeroFmt = `#${String(numero).padStart(6, "0")}`;
  const shareText = `${firma ? `${firma}: ` : ""}\u201c${testo}\u201d \u2014 Il Museo delle Promesse`;
  try {
    const resp = await fetch(imgUrl);
    if (resp.ok) {
      const blob = await resp.blob();
      const file = new File([blob], `messaggio-${String(numero).padStart(6, "0")}.png`, { type: "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: `Messaggio ${numeroFmt}`, text: shareText });
        return;
      }
      // Fallback: scarica/apre l'immagine
      const objUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objUrl;
      a.target = "_blank";
      a.download = `messaggio-${String(numero).padStart(6, "0")}.png`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objUrl);
      if (toast) toast.success("Immagine salvata");
      return;
    }
  } catch {
    /* ignore */
  }
  window.open(imgUrl, "_blank");
};
